import Wrap from "../../../components/wrap";
import integration from "../../../assets/imgs/integration.jpg"

export default function Integration() {

    return (
        <section className="integration-section">
            <Wrap>
                <h2 className="section-title">Multiple Integration</h2>
                <p className="section-desc text-black">Offers publishers the opportunity for integration in various options through Script Code, Prebid Client/S2S, Open RTB, and Mobile Application SDKs.</p>
                <img src={integration} alt="Pixad Integration"/>
            </Wrap>
        </section>
    )
}
